import Accordions from './Accordions';
import AutoLogout from './AutoLogout';
import ClientSideValidation from './ClientSideValidation';
import LegacyDateValidator from './LegacyDateValidator';
import MessageCenter from './MessageCenter';
import Modals from './Modals';
import PagePrinter from './PagePrinter';
import RadialGraphs from './RadialGraphs';
import AutoRefresh from './AutoRefresh';
import TextSizer from './TextSizer';
import Tutorials from './Tutorials';
import Tooltip from './Tooltip';

/**
 * Application setup
 *
 * @class App
 */
export default class App {
    constructor() {
        new Accordions();
        new AutoLogout();
        new AutoRefresh();
        this.validation = new ClientSideValidation();
        new LegacyDateValidator();
        new MessageCenter();
        new Modals();
        new PagePrinter();
        new RadialGraphs();
        new TextSizer();
        new Tutorials();
        new Tooltip();
    }
}
